import React from 'react';

var reviewLayers = {
    "2DLayer": [
        {
            ID: "(管線分布圖)消防栓"
        },
        {
            ID: "(管線分布圖)號誌"
        },
        {
            ID: "(管線分布圖)電桿"
        },
    ],
    "3DLayer": [
        {
            ID: "pipeline"
        },
    ]
}

export default reviewLayers;